export default {
    approvals: {
        title: "Goedkeuring",
        error: "Er is een fout opgetreden"
    },
    delegates: {
        title: "Afgevaardigden",
        error: "Er is een fout opgetreden",
        noDelegates: "Geen items",
        delegateDelete: "Gedelegeerde is verwijderd",
        confirm: {
            delete: "Gedelegeerde verwijderen?"
        },
        delegates: {
            email: "E-mail",
            startDate: "Startdatum",
            endDate: "Einddatum",
        },
        buttons: {
            add: {
                text: "Gedelegeerde toevoegen"
            }
        }
    },
    employees: {
        title: "Mijn medewerkers",
        error: "Er is een fout opgetreden",
        empty: "Geen medewerkers gevonden",
        users: {
            name: "Naam",
            email: "E-mail"
        },
        model: {
            search: {
                placeholder: "Zoekopdracht",
            }
        },
        cta: {
            orders: "Laadorders",
            download: "Download bestellingen",
            search: "Zoekopdracht"
        }
    }
}